module.exports = __webpack_public_path__ + "img/Wallet-PicPay.005a076.png";